import BatchHeaderSection from "./BatchHeaderSection";
import BatchListComponent from "./BatchListComponent";

const BatchSetupComponent = () => {
  return (
    <>
      <BatchHeaderSection />
      <BatchListComponent />
    </>
  );
};

export default BatchSetupComponent;
